export function enabled() {
    return !!module.hot;
}
